import { Dialog, Notify, QSpinnerBall } from 'quasar';
import { Types } from 'src/api/ws-handler';
import { Distribution } from 'src/api';

export let dismissReconnectNotify: () => void = () => null;
export let dismissConnectingNotify: () => void = () => null;
export let dismissDisconnectedNotify: () => void = () => null;
export let dismissReconnectErrorNotify: () => void = () => null;

export const showReconnectNotify = () => {
  dismissReconnectNotify = Notify.create({
    message: 'Connection lost. Reconnecting...',
    spinner: true,
    group: 'connect',
    timeout: 0,
    // type: 'ongoing',
    // closeBtn: true,
  });
};
export const showConnectingNotify = () => {
  dismissConnectingNotify = Notify.create({
    message: 'Connecting...',
    spinner: QSpinnerBall,
    group: 'connect',
    timeout: 0,
    // type: 'ongoing',
  });
};
export const showDisconnectedNotify = (
  message: string,
  authenticate: () => void,
  reconnect: () => void
) => {
  dismissConnectingNotify();

  const actions = [];

  reconnect &&
    actions.push({
      label: 'Retry...',
      color: 'white',
      // icon: 'mdi-power-plug',
      handler: () => {
        dismissDisconnectedNotify();
        reconnect();
      },
    });

  authenticate &&
    actions.push({
      label: 'Auth...',
      color: 'white',
      // icon: 'mdi-close',
      handler: () => authenticate(),
    });

  actions.push({
    label: 'Refresh...',
    color: 'white',
    // icon: 'mdi-close',
    handler: () => document.location.reload(),
  });

  dismissDisconnectedNotify = Notify.create({
    message: 'Server has Rejected Connection',
    caption: message,
    type: 'negative',
    group: 'disconnect',
    closeBtn: false,
    timeout: 0,
    actions,
  });
};

export const showReconnectErrorNotify = (
  limit: number,
  authenticate: () => void
) => {
  dismissReconnectErrorNotify = Notify.create({
    message: `[DEBUG] Unable to connect after ${limit} attempts`,
    type: 'negative',
    group: 'disconnect',
    closeBtn: true,
    timeout: 0,
    actions: [
      {
        label: 'Refresh auth...',
        color: 'white',
        handler: authenticate,
      },
      {
        label: 'Reload app...',
        color: 'white',
        // icon: 'mdi-close',
        handler: () => document.location.reload(),
      },
    ],
  });
};

export const showServerErrorMessageNotify = (data: Types.ErrorMessageData) => {
  const isDebug = process.env.DEBUGGING as unknown as boolean;
  return showErrorMessageNotify({
    message: data.message,
    caption: data.error || 'Server Message',
    position: 'bottom-left',
    timeout: isDebug ? 0 : 5000,
    group: true,
    progress: !isDebug,
    close: isDebug,
  });
};

export const showErrorMessageNotify = (opts: {
  message: string;
  caption?: string;
  position?: string;
  timeout?: number;
  close?: boolean;
  progress?: boolean;
  group?: string | boolean;
  type?: string;
}) => {
  return Notify.create({
    message: opts.message,
    caption: opts.caption || '',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    position: opts.position || 'top-right',
    type: opts.type || 'negative',
    group: opts.group || false,
    progress: opts.progress || false,
    closeBtn: typeof opts.close !== 'undefined',
    timeout: opts.timeout === 0 ? 0 : opts.timeout || 3000,
  }) as () => void;
};

export const showPostingDeliveredNotify = (count: number, boardId: number) => {
  Notify.create({
    message: `${count} posting(s) delivered.`,
    caption: `Board #${boardId}`,
    icon: 'mdi-message-alert-outline',
    position: 'bottom-right',
  });
};

export const showPostingValidatedNotify = (count: number, boardId: number) => {
  Notify.create({
    message: `${count} posting(s) validated.`,
    caption: `Board #${boardId}`,
    icon: 'mdi-message-alert-outline',
    position: 'bottom-right',
  });
};

export const showAccessDeniedNotify = (pageTitle: string, onOk: () => void) => {
  Dialog.create({
    title: 'Access Denied',
    position: 'top',
    color: 'red',
    cancel: true,
    persistent: false,
    dark: false,
    html: true,
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    message: `Your account doesn't allowed to access <strong>${pageTitle}</strong> page.
<br/>Would you like to logout and use another?`,
  }).onOk(onOk);
  // .onCancel(() => closeDialog());
  //.onDismiss(() => {
  // console.log('I am triggered on both OK and Cancel')
  //})
};

export const showPleaseSignInNotify = () => {
  Notify.create({
    message: 'Please Sign In to Continue',
    icon: 'mdi-message-alert-outline',
    position: 'top',
    timeout: 1500,
  });
};

export const showDeliveryStatusChangeNotify = (
  active: boolean,
  type: Distribution.Types.DeliveryStatusType,
  boardsCount: number
) => {
  Notify.create({
    message: `${boardsCount} ${
      type === 'global' ? 'Global' : 'Local'
    } Boards were ${active ? 'Activated' : 'Deactivated'}`,
    type: active ? 'positive' : 'warning',
    icon: active ? 'mdi-check-circle' : 'mdi-alert-circle',
    position: 'bottom-right',
  });
};

export const showTextCopiedMessage = () => {
  Notify.create({
    type: 'positive',
    message: 'Execution Message Copied to Clipboard',
    icon: 'mdi-check',
    position: 'top',
    timeout: 1000,
  });
};
